<script setup lang="ts">
import { JobJson } from '@/models/types/job-json'
import { useRouter } from 'vue-router/composables'
import { useJobSearchRouteContext } from '@/common/useJobSearchRouteContext'

const props = defineProps<{
  value?: string | null
  job: JobJson
}>()

const router = useRouter()
const { batchRouteName } = useJobSearchRouteContext()

function handleClick() {
  const batchId = props.job.invoice_id ?? ''
  router.push({
    name: batchRouteName.value,
    params: {
      batchId,
    },
  })
}
</script>

<template>
  <button v-if="value" @click.stop="handleClick">{{ value }}</button>
</template>

<style scoped>
button {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  color: #0000ee;
  text-decoration: underline; /* Underline text to resemble a link */
  display: inline; /* Ensure the button takes only as much width as its content */
}

/* Remove default button styles */
button:focus {
  outline: none;
}
</style>
